import * as React from "react";
import { Modal, Card, Loader } from "@grandvisionhq/common";
/* empty css                 */
const LoaderModal = ({ isModalOpen, heading, subheading }) => {
  return /* @__PURE__ */ React.createElement(
    Modal,
    {
      isOutsideClickEnabled: false,
      isOpen: isModalOpen,
      className: "loader-modal",
      title: heading,
      activeTrap: false
    },
    /* @__PURE__ */ React.createElement(Card, null, /* @__PURE__ */ React.createElement(Card.Content, { className: "loader-modal__content" }, /* @__PURE__ */ React.createElement(Card.Section, { className: "loader-modal__loader" }, /* @__PURE__ */ React.createElement(Loader, { className: "loader-modal__loader-icon" })), /* @__PURE__ */ React.createElement(Card.Section, { className: "loader-modal__subheading" }, /* @__PURE__ */ React.createElement(Card.Text, { variant: "body" }, subheading))))
  );
};
export {
  LoaderModal
};
//# sourceMappingURL=LoaderModal.js.map
